var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 3H2C1.73333 3 1.48 3.10667 1.29333 3.29333C1.10667 3.48 1 3.73333 1 4V12C1 12.2667 1.10667 12.52 1.29333 12.7067C1.48 12.8933 1.73333 13 2 13H14C14.2667 13 14.52 12.8933 14.7067 12.7067C14.8933 12.52 15 12.2667 15 12V4C15 3.73333 14.8933 3.48 14.7067 3.29333C14.52 3.10667 14.2667 3 14 3ZM12.9 4L8 7.39333L3.1 4H12.9ZM2 12V4.45333L7.71333 8.40667C7.8 8.46667 7.89333 8.49333 8 8.49333C8.10667 8.49333 8.2 8.46 8.28667 8.40667L14 4.45333V12H2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipEmail);
export default __webpack_public_path__ + "static/media/ic-chip-email.32bc755bb7b4a0672b8877adb93f259c.svg";
export { ForwardRef as ReactComponent };